export function resolveContainerBinding(container, serviceIdentifier) {
    const [instance] = container.getAll(serviceIdentifier);
    if (null == instance) throw new Error(`No binding found for ${String(serviceIdentifier)}.`);
    return instance;
}

export function createContributionProvider(serviceIdentifier, container) {
    let caches;
    return {
        getContributions: () => (caches || (caches = container.isBound(serviceIdentifier) ? container.getAll(serviceIdentifier) : []), 
        caches)
    };
}
//# sourceMappingURL=explicit-binding.js.map